var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJsp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 84 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #010101;\n      }\n\n      .cls-2 {\n        fill: #fff;\n        fill-rule: evenodd;\n      }\n\n      .cls-3 {\n        fill: #f2f2f3;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -1.9,
    y: -2.1,
    width: 87.8,
    height: 99.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4803.7-375.5h2500v2500h-2500V-375.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.1,70.1c-.9,0-1.5,0-1.9.2v5.7c.4,0,.8,0,1.5,0,2.3,0,3.8-1.2,3.8-3.1s-1.2-2.9-3.4-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.1,25.2c0-.4,0-.8-.4-1.1L56.9,5.1h0c0,0-.2-.2-.4-.3h0c0,0-.2,0-.4-.2H14.7c-1.9,0-3.4,1.5-3.4,3.4v79.9c0,1.9,1.5,3.4,3.4,3.4h56.1c1.9,0,3.4-1.5,3.4-3.4V25.2h0ZM32.7,79.2c0,5.6-2.7,7.4-6.9,7.4s-2.3-.2-3.1-.5l.5-3.5c.6.2,1.4.4,2.2.4,1.9,0,3-.8,3-3.9v-12.2h4.3v12.2h0ZM41.1,86.7c-2.2,0-4.4-.6-5.5-1.2l.9-3.6c1.2.6,3,1.2,4.8,1.2s3.1-.8,3.1-2.1-.9-1.9-3.2-2.8c-3.2-1.1-5.3-2.9-5.3-5.7s2.8-5.8,7.3-5.8,3.8.5,4.9,1l-1,3.5c-.7-.4-2.1-.9-4.1-.9s-2.8.8-2.8,1.9,1.1,1.8,3.6,2.8c3.4,1.3,5,3.1,5,5.7s-2.5,6-7.9,6h0ZM64,77.5c-1.5,1.4-3.7,2-6.3,2s-1.1,0-1.5,0v6.9h-4.3v-19.2c1.4-.2,3.2-.4,5.9-.4s4.6.6,5.9,1.6c1.2,1,2,2.6,2,4.4s-.6,3.5-1.8,4.6h0ZM14.6,62.2V7.9h39.3v17.4c0,.9.7,1.7,1.7,1.7h15v35.3H14.5h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.7,36.6s-2.3-4.4-2.2-7.6c0-2.3,5.3-4.5,7.3-7.9,2-3.3-.3-6.5-.3-6.5,0,0,.5,2.4-.8,4.8-1.4,2.4-6.4,3.9-8.3,8.1-1.9,4.3,4.3,9.1,4.3,9.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.3,23.3s-7.8,3-7.8,6.4,2.1,4.4,2.5,5.6c.4,1.1-.6,3-.6,3,0,0,3.1-2.1,2.5-4.5-.5-2.5-2.9-3.2-1.5-5.6.9-1.7,4.9-4.6,4.9-4.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.9,41.1c8.1-.3,9-1.8,9.8-2.5-4.6,1.3-17,1.2-17.1.3,0-.9,3.8-1.7,3.8-1.7,0,0-6.1,0-6.6,1.5-.6,1.5,2.9,2.7,10.1,2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.9,37.4s3.4,0,3.8,2.1-4.3,5.3-4.3,5.3c0,0,7.5-1.5,6.8-5.4-.8-4.6-6.2-2-6.2-2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.5,43.5c-3.5.4-7.8,0-8.1-.6s.6-.9.6-.9c-4.3,1-1.9,2.8,3.1,3.1,4.3.3,9-1.3,9-1.3l1.5-1.2s-3.3.5-6,.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.9,46.3s-1.9,0-2,1.1c0,1,.6,1.5,5.4,1.4,5.6,0,6.6-.8,7.1-1.3l1.4-1c-3.7.5-4,.6-6.1.6s-5.8.2-5.9-.2c-.2-.4.2-.6.2-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.4,51c.7-.8-.2-1.4-.2-1.4,0,0,.4.4,0,.8s-4.5,1.6-11.2,1.9c-6.6.4-13.8-.6-14-1.5-.2-.8,3.7-1.5,3.7-1.5-.5,0-5.8.2-6,1.7s2.4,2.7,12.5,2.7,14.6-1.9,15.4-2.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.5,54.3c-4.4.9-18,.4-18,.4,0,0,8.8,2.1,18.8.4,4.8-.8,5.1-3.1,5.1-3.1,0,0-1.5,1.6-5.9,2.5h0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJsp);
export default __webpack_public_path__ + "static/media/JSP.feb6685cc125d149a30f9065cbf6d6bd.svg";
export { ForwardRef as ReactComponent };